/* eslint-disable import/no-mutable-exports */
import GoogleSheetContainer from "./GoogleSheetContainer";

export default GoogleSheetContainer;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/GoogleSheetContainer/index.js